"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockTimestampFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockTimestampFactory = /** @class */ (function (_super) {
    __extends(MockTimestampFactory, _super);
    function MockTimestampFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockTimestampFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockTimestampFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockTimestampFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockTimestampFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockTimestampFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockTimestampFactory;
}(contracts_1.ContractFactory));
exports.MockTimestampFactory = MockTimestampFactory;
var _abi = [
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405260008055348015601357600080fd5b5060ab806100226000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c80631e2ff94f14603757806366efcb7814604c575b600080fd5b60005460405190815260200160405180910390f35b605c6057366004605e565b600055565b005b600060208284031215606e578081fd5b503591905056fea264697066735822122036e5b8c259caab8e45030cec9ce028418a993f8c800f3e58e1536558ac20c17264736f6c63430008040033";
